import { ModuleValueGeneral, SchemaModuleGeneral } from './module-general';
import { JSONSchema } from '../types/json-schema';
import { FormComponent } from '../form.component';

import * as rawJSONSchemaModuleCancerVulval from '../../schemas/module-cancer-vulval.json';

class ModuleValueCancerVulval extends ModuleValueGeneral {
  // Step 1
  date_of_birth?: string;
  date_of_diagnosis?: string;

  // Step 2
  main_procedure?: string;
  date_of_surgery?: string;
  date_radiation_commenced?: string;

  // Step 3
  // recurrence_progression_date?: string;
  date_last_follow_up?: string;
  follow_up_duration?: number;
  follow_up_duration_compute?: boolean;
}

export class SchemaModuleCancerVulval extends SchemaModuleGeneral<ModuleValueCancerVulval> {
  schema: JSONSchema<ModuleValueCancerVulval>;

  constructor() {
    super();

    this.loadSchema( rawJSONSchemaModuleCancerVulval );
  }

  hook( form: FormComponent ) {
    super.hook( form );

    this.listenValue( 'follow_up_duration_compute', this.fieldHandlerFollowUpDurationCompute.bind( this ) );

    this.listenValue(
      [ 'date_last_follow_up', 'main_procedure', 'date_of_surgery', 'date_radiation_commenced' ],
      this.fieldHandlerCalculateFollowUpDuration.bind( this )
    );
  }

  fieldHandlerCalculateFollowUpDuration(
    followUpDate: string,
    mainProcedure: string,
    surgeryDate: string,
    radiationDate: string,
  ) {
    if ( !this.getValue( 'follow_up_duration_compute' ) ) return;
    const startDate = this.resolveStartDate( mainProcedure, surgeryDate, radiationDate );
    this.updateValue( 'follow_up_duration', this.diffInMonths( followUpDate, startDate, 30.5 ) );
  }

  fieldHandlerFollowUpDurationCompute( compute: boolean ) {
    if ( typeof compute === 'undefined' || compute === null ) return;
    this.schema.properties[ 'follow_up_duration' ].readOnly = compute;

    if ( compute ) {
      this.fieldHandlerCalculateFollowUpDuration(
        this.getValue( 'date_last_follow_up' ),
        this.getValue( 'main_procedure' ),
        this.getValue( 'date_of_surgery' ),
        this.getValue( 'date_radiation_commenced' ),
      );
    }
  }

  private resolveStartDate(
    mainProcedure: string,
    surgeryDate: string,
    radiationDate: string,
  ): string {
    if ( mainProcedure === 'upfront_chemoradiation' ) return radiationDate;
    return surgeryDate;
  }

  setupValidators() {
    super.setupValidators();

    this.validatorDateComparison( 'date_of_diagnosis', 'date_of_birth', '>' );

    this.validatorDateComparison( 'date_of_surgery', 'date_of_birth', '>' );
    this.validatorDateComparison( 'date_of_surgery', 'date_of_diagnosis', '>=' );

    this.validatorDateComparison( 'date_radiation_commenced', 'date_of_birth', '>' );
    this.validatorDateComparison( 'date_radiation_commenced', 'date_of_diagnosis', '>=' );

    // this.validatorDateComparison( 'recurrence_progression_date', 'date_of_birth', '>' );
    // this.validatorDateComparison( 'recurrence_progression_date', 'date_of_diagnosis', '>=' );
    // this.validatorDateComparison( 'recurrence_progression_date', 'date_of_surgery', '>=' );

    // this.validatorDateComparison( 'date_last_follow_up', 'date_of_birth', '>' );
    // this.validatorDateComparison( 'date_last_follow_up', 'date_of_diagnosis', '>=' );
    // this.validatorDateComparison( 'date_last_follow_up', 'date_of_surgery', '>=' );

    this.validatorDate( 'date_of_birth', ( new Date() ), '<=' , v => new Date( v as any ));
    this.validatorDate( 'date_of_diagnosis', ( new Date() ), '<=' , v => new Date( v as any ));
  }
}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-cancer-vulval.ts